<template>
    <l-marker :lat-lng="[latitude, longitude]">
        <AlarmTooltip v-if="alarm != null" :alarm="alarm" />

        <l-icon class-name="someExtraClass" style="z-index: 1;" :icon-size="[32, 32]" :icon-anchor="[16, 48]">
            <div>
                <font-awesome-icon
                    :icon="['fas', 'location-pin']"
                    class="text-center"
                    :class="alarmDisplay.pinColor"
                    size="4x"
                />

                <span class="badge text-nowrap bg-white fw-bold align-baseline rounded-circle map-notification-icon">
                    <font-awesome-icon
                        :icon="['fas', alarmDisplay.icon]"
                        class="text-center"
                        :class="alarmDisplay.color"
                        size="2xl"
                    />
                </span>
            </div>
        </l-icon>
    </l-marker>
</template>

<script>
import AlarmTooltip from './AlarmTooltip.vue';
import { LMarker, LIcon } from "@vue-leaflet/vue-leaflet";
import { resolveAlarmDisplay } from '@/helpers/alarmDisplay.helper.js';

export default {
    props: {
        latitude: {
            required: true
        },
        longitude: {
            required: true
        },
        notification: {
            type: String,
            default: "default",
            required: false
        },
        alarm: {
            default: null,
            required: false
        }
    },

    computed: {
        alarmDisplay() {
            if (this.alarm) {
                return resolveAlarmDisplay(this.alarm);
            }

            return this.resolveNotificationDisplay();
        }
    },

    methods: {
        resolveNotificationDisplay() {
            switch (this.notification) {
                case 'start':
                    return {
                        text: "Début trajet",
                        icon: "circle-play",
                        color: "alarm-color-success",
                        pinColor: "alarm-color-info",
                    };

                case 'finish':
                    return {
                        text: "Fin trajet",
                        icon: "flag-checkered",
                        color: "alarm-color-muted",
                        pinColor: "alarm-color-info",
                    };

                case 'speed':
                    return {
                        text: "Vitesse",
                        icon: "gauge-high",
                        color: "alarm-color-danger",
                        pinColor: "alarm-color-danger",
                    };

                case 'corridoring-in':
                    return {
                        text: "Entrée corridoring",
                        icon: "circle-check",
                        color: "alarm-color-primary",
                        pinColor: "alarm-color-info",
                    };

                default:
                    return {
                        text: "N.C",
                        icon: "triangle-exclamation",
                        color: "alarm-color-danger",
                        pinColor: "alarm-color-danger",
                    };
            }
        }
    },

    components: {
        LMarker,
        LIcon,
        AlarmTooltip
    }
}
</script>

<style>
.map-notification-icon {
    position: absolute;
    top: 4px;
    left: 3px;
}
</style>